import { UseQueryOptions } from '@tanstack/react-query';
import useAppQuery from 'hooks/useAppQuery';
import { BaseErrorResponse } from 'models/_base';
import { CustomTemplateWithLocales } from 'models/automation/CustomTemplates';
import API from 'services/API';
import { CUSTOM_TEMPLATES_BASE_QUERY_KEY } from './customTemplatesQuery';

type ReactQueryOptions = Omit<
  UseQueryOptions<CustomTemplateWithLocales, BaseErrorResponse>,
  'queryKey' | 'queryFn'
>;

type UseFetchCustomTemplateByUidArgs = {
  customTemplateUid?: string;
} & ReactQueryOptions;

const useFetchCustomTemplateByUid = ({
  customTemplateUid,
  enabled = !!customTemplateUid,
  ...options
}: UseFetchCustomTemplateByUidArgs) => {
  return useAppQuery<CustomTemplateWithLocales, BaseErrorResponse>({
    queryKey: [CUSTOM_TEMPLATES_BASE_QUERY_KEY, 'detail', customTemplateUid],
    queryFn: async () => {
      const response = await API.get<CustomTemplateWithLocales>(
        `/api/internal/automation/custom-templates/${customTemplateUid}`,
      );

      return response.data;
    },
    enabled,
    ...options,
  });
};

export default useFetchCustomTemplateByUid;
